// extracted by mini-css-extract-plugin
export default {"radii-sm":"0px","radii-full":"50px","radii-blur":"12px","transitions-in":"all .065s","transitions-out":"all .192s"};